import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";

export function VendorPriceListLinkDetailFallbackFields(): FormlyFieldConfig[] {
    const fieldClass = "w-full md:w-1/4 sm:w-1/2";

    return [
        {
            className: "w-full",
            fieldGroupClassName: "flex flex-col gap-4",
            fieldGroup: [
                {
                    className: "w-full",
                    fieldGroupClassName: "flex flex-wrap",
                    wrappers: ["simple-title"],
                    props: {
                        label: _("common.vendor-order-details"),
                        translate: true,
                        hrBelowTitle: true,
                    },
                    fieldGroup: [
                        {
                            key: 'orderNumber',
                            className: fieldClass,
                            type: 'input',
                            props: {
                                label: _('common.vendor-orderNumber'),
                                translate: true,
                                attributes: {
                                    'data-testid': 'formly-order-number-input'
                                }
                            }
                        },
                        {
                            key: 'deliveryDays',
                            className: fieldClass,
                            type: 'input',
                            props: {
                                label: _('common.vendor-deliveryDays'),
                                translate: true,
                                type: "number",
                                min: 0,
                                attributes: {
                                    'data-testid': 'formly-delivery-days-input'
                                }
                            }
                        },
                        {
                            key: 'minQuantity',
                            className: fieldClass,
                            type: 'input',
                            props: {
                                minFractionDigits: 2,
                                label: _('common.vendor-minQuantity'),
                                translate: true,
                                type: "number",
                                attributes: {
                                    'data-testid': 'formly-minimum-amount-input'
                                }
                            }
                        },
                        {
                            key: 'unit',
                            className: fieldClass,
                            type: 'formly-unit-drop-down',
                            props: {
                                label: _('common.vendor-unit'),
                                translate: true,
                                attributes: {
                                    autoSelectSingleResult: 0,
                                    'data-testid': 'formly-unit-drop-down'
                                },
                            }
                        },
                        {
                            key: 'vendorPriceList.currency',
                            className: fieldClass,
                            type: 'formly-generic-enum-drop-down',
                            props: {
                                label: _('common.currency'),
                                translate: true,
                                attributes: {
                                    enumName: 'CurrencyCode',
                                    'data-testid': 'formly-delivery-currency-input'
                                }
                            }
                        },
                    ],
                },
                {
                    className: "w-full",
                    fieldGroupClassName: "flex flex-wrap",
                    wrappers: ["simple-title"],
                    props: {
                        label: _("common.prices"),
                        translate: true,
                        hrBelowTitle: true,
                    },
                    fieldGroup: [
                        {
                            key: 'priceUnit',
                            className: fieldClass,
                            type: 'input',
                            props: {
                                label: _('common.vendor-priceUnit'),
                                translate: true,
                                type: "number",
                                attributes: {
                                    'data-testid': 'formly-price-unit-input'
                                }
                            }
                        },
                        {
                            key: 'lotSize',
                            className: fieldClass,
                            type: 'input',
                            props: {
                                label: _('common.vendor-lotSize'),
                                translate: true,
                                type: "number",
                                attributes: {
                                    'data-testid': 'formly-lot-size-input'
                                }
                            }
                        },
                        {
                            key: 'discount1',
                            className: fieldClass,
                            type: 'input',
                            props: {
                                label: _('common.discount1'),
                                translate: true,
                                type: "number",
                                attributes: {
                                    'data-testid': 'formly-discount1-input'
                                }
                            }
                        },
                        {
                            key: 'discount2',
                            className: fieldClass,
                            type: 'input',
                            props: {
                                label: _('common.discount2'),
                                translate: true,
                                type: "number",
                                attributes: {
                                    'data-testid': 'formly-discount2-input'
                                }
                            }
                        },
                    ],
                },
                {
                    className: "w-full",
                    fieldGroupClassName: "flex flex-wrap",
                    wrappers: ["simple-title"],
                    props: {
                        label: _("common.vendor-costs"),
                        translate: true,
                        hrBelowTitle: true,
                    },
                    fieldGroup: [
                        {
                            key: 'freightCost',
                            className: fieldClass,
                            type: 'input',
                            props: {
                                minFractionDigits: 2,
                                label: _('common.vendor-freightCost'),
                                translate: true,
                                type: "number",
                                attributes: {
                                    'data-testid': 'formly-freight-cost-input'
                                }
                            }
                        },
                        {
                            key: 'customsCost',
                            className: fieldClass,
                            type: 'input',
                            props: {
                                minFractionDigits: 2,
                                label: _('common.vendor-customsCost'),
                                translate: true,
                                type: "number",
                                attributes: {
                                    'data-testid': 'formly-customs-cost-input'
                                }
                            }
                        },
                    ],
                },
                {
                    className: "w-full",
                    fieldGroupClassName: "flex flex-wrap",
                    wrappers: ["simple-title"],
                    props: {
                        label: _("common.settings"),
                        translate: true,
                        hrBelowTitle: true,
                    },
                    fieldGroup: [
                        {
                            key: 'nonDiscountable',
                            className: "flex items-center w-full md:w-1/4 sm:w-1/2",
                            type: 'checkbox',
                            props: {
                                label: _("common.vendor-nonDiscountable"),
                                hint: _("common.vendor-nonDiscountable-hint"),
                                translate: true,
                                indeterminate: false,
                                attributes: {
                                    'data-testid': 'formly-non-discountable-checkbox'
                                }
                            },
                        },
                        {
                            key: 'nonCashDiscountable',
                            className: "flex items-center w-full md:w-1/4 sm:w-1/2",
                            type: 'checkbox',
                            props: {
                                label: _("common.vendor-nonCashDiscountable"),
                                hint: _("common.vendor-nonCashDiscountable-hint"),
                                translate: true,
                                indeterminate: false,
                                attributes: {
                                    'data-testid': 'formly-non-cash-discountable-checkbox'
                                }
                            },
                        },
                    ],
                },
            ]
        }
    ];
}
